import React from 'react'
import styled from 'styled-components'

import Logic from './logic'
import { GAS_OFFER_TYPE, ELECTRICITY_OFFER_TYPE, isEnterprise } from 'config'
import { pickOrNot } from 'utils'
import Form from 'containers/Form'

import Section from 'components/Section'
import RadioGroup from 'components/RadioGroup'
import TableItem from 'components/TableItem'
import PlusButton from 'components/PlusButton'
import FixedWrapper from 'components/FixedWrapper'
import Tip from 'components/Tip'

const MAX_LIST_ITEMS = 12

/* eslint-disable camelcase */
@Logic
export default class Consume extends Form {
  nextText = `Simular`
  prevText = `Passo Anterior`

  componentDidMount () {
    // Scrols to top on component mount
    setTimeout(() => {
      const element = document.getElementById('anchor')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)
  }

  next = () => {
    const { valid, invalid } = this.isFormValid()
    const { setFinished, setInvalid } = this.actions
    const { router } = this.props

    if (valid) {
      setFinished({ consumeFinished: true })
      setInvalid(null)
      router.push('/resultados')
    } else {
      setFinished({ consumeFinished: false })
      setInvalid(invalid)

      let electricityListInvalid = pickOrNot(invalid, ['electricityConsumptionsRegistration'])
      let gasListInvalid = pickOrNot(invalid, ['gasConsumptionsRegistration'])

      if (electricityListInvalid) {
        let el = document.getElementById('electricityConsumptionsRegistration')
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
        return false
      }

      if (gasListInvalid) {
        let el = document.getElementById('gasConsumptionsRegistration')
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }

        return false
      }
    }
  }

  prev = () => {
    const { router } = this.props
    router.push('/faturacao')
  }

  /**
   * Logic to be applied to values based on
   * consumptionDisaggregation value
   */
  consumptionDisaggregationLogic = (values) => {
    const { consumptionDisaggregation } = this.props.values
    let { simples, cheias } = values

    switch (consumptionDisaggregation) {
      // Fill all fields with simples value
      case 's':
        if (simples) {
          values.svazio = simples
          values.cheias = simples
          values.ponta = simples
        }
        return values

      case 'vf':
        if (simples) {
          values.svazio = simples
        }

        if (cheias) {
          values.ponta = cheias
        }

        return values
      case 'vcp':
        if (simples) {
          values.svazio = simples
        }
        return values
      case 'vscp':

        return values
      default:
        return values
    }
  }

  /**
   * Sets the value of the electricity element by index
   */
  setTableElectricityValues = (values, index) => {
    const { setValues } = this.actions
    const {
      electricityConsumptionsRegistration
    } = this.props.values

    values = this.consumptionDisaggregationLogic(values)

    const item = electricityConsumptionsRegistration[index]

    electricityConsumptionsRegistration[index] = { ...item, ...values }

    setValues({ electricityConsumptionsRegistration })
  }

  /**
   * Removes an element from the table list of electricity
   */
  onRemoveElectricityValue = (index) => {
    const { setValues } = this.actions
    let {
      electricityConsumptionsRegistration
    } = this.props.values

    let clone = [...electricityConsumptionsRegistration]

    if (clone.length > 1) {
      clone.splice(index, 1)
    }

    setValues({ electricityConsumptionsRegistration: clone })
  }

  /**
   * Adds new eletricity table value to state
   */
  addNewElectricityTableValue = () => {
    const { setValues } = this.actions
    let {
      electricityConsumptionsRegistration
    } = this.props.values

    if (electricityConsumptionsRegistration.length >= MAX_LIST_ITEMS) {
      return false
    }

    electricityConsumptionsRegistration.push({
      startDate: null,
      endDate: null,
      simples: '',
      svazio: '',
      cheias: '',
      ponta: ''
    })

    setValues({ electricityConsumptionsRegistration })
  }

    /**
   * Sets the value of the gas element by index
   */
  setTableGasValues = (values, index) => {
    const { setValues } = this.actions
    const {
      gasConsumptionsRegistration
    } = this.props.values

    const item = gasConsumptionsRegistration[index]

    gasConsumptionsRegistration[index] = { ...item, ...values }

    setValues({ gasConsumptionsRegistration })
  }

  /**
   * Removes an element from the table list of gas
   */
  onRemoveGasValue = (index) => {
    const { setValues } = this.actions
    let {
      gasConsumptionsRegistration
    } = this.props.values

    if (gasConsumptionsRegistration.length > 1) {
      gasConsumptionsRegistration.splice(index, 1)
    }

    setValues({ gasConsumptionsRegistration })
  }

  /**
   * Adds a new gas table value to state
   */
  addNewGasTableValue = () => {
    const { setValues } = this.actions
    let {
      gasConsumptionsRegistration
    } = this.props.values

    if (gasConsumptionsRegistration.length >= MAX_LIST_ITEMS) {
      return false
    }

    gasConsumptionsRegistration.push({
      startDate: null,
      endDate: null,
      consumption: ''

    })

    setValues({ gasConsumptionsRegistration })
  }

  render () {
    const { setValues } = this.actions

    const {
      consumptionDisaggregations
    } = this.props.filters

    const {
      offerType,
      invalid,
      translations,
      iframed
    } = this.props

    const {
      consumptionDisaggregation,
      electricityConsumptionsRegistration,
      gasConsumptionsRegistration,
      ciclo_horario
    } = this.props.values

    const {
      ELECTRICITY_SEGREGATION,
      ELECTRICITY_CONSUMPTION_REGISTRY,
      GAS_CONSUMPTION_REGISTRY
    } = translations || {}

    // Check if gas or electricity or both
    const isGas = offerType &&
      offerType.slug
      .indexOf(GAS_OFFER_TYPE) !== -1

    const isElectricity = offerType &&
      offerType.slug
      .indexOf(ELECTRICITY_OFFER_TYPE) !== -1

    // Check if MAX_ITEMS is not reached!
    const canAddElectricityItems = electricityConsumptionsRegistration &&
    electricityConsumptionsRegistration.length < MAX_LIST_ITEMS

    const canAddGasItems = gasConsumptionsRegistration &&
    gasConsumptionsRegistration.length < MAX_LIST_ITEMS

    let electricityListInvalid = invalid && invalid.electricityConsumptionsRegistration
    let gasListInvalid = invalid && invalid.gasConsumptionsRegistration

    // If ciclo_horario selected in faturation is BI horario cannot let
    // select a simple disaggregation
    // https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/25
    let filteredConsumptionDisaggregations
    const BI_HORARY = 'b'
    const SIMPLE_ID = 's'
    const ENTERPRISE_ID = 'vscp'

    if (ciclo_horario === BI_HORARY) {
      filteredConsumptionDisaggregations = consumptionDisaggregations.filter((item) => {
        return item.id !== SIMPLE_ID
      })
    }
    if (!isEnterprise) {
      if (!filteredConsumptionDisaggregations) {
        filteredConsumptionDisaggregations = consumptionDisaggregations.filter((item) => {
          return item.id !== ENTERPRISE_ID
        })
      } else {
        filteredConsumptionDisaggregations = filteredConsumptionDisaggregations.filter((item) => {
          return item.id !== ENTERPRISE_ID
        })
      }
    }
    return (
      <Wrapper>
        {this.renderNavbar()}
        <FixedWrapper>
          {isElectricity &&
          <Section
            title={`Desagregação dos consumos de eletricidade`}
            subtitle={`Como se encontram desagregadas as leituras dos seus consumos?`}
            compact={iframed}
          >
            {ELECTRICITY_SEGREGATION &&
              <Tip data-slot='tip' text={ELECTRICITY_SEGREGATION} />}
            {consumptionDisaggregations &&
            <RadioGroup
              items={filteredConsumptionDisaggregations || consumptionDisaggregations}
              value={consumptionDisaggregation}
              name='consumption_disaggregation'
              onSelectionChange={({ value }) => setValues({ consumptionDisaggregation: value })}
              />
          }
          </Section>
          }

          {isElectricity &&
          <Section
            title={`Registo dos consumos de eletricidade`}
            subtitle={`INTRODUZA ATÉ UM MÁXIMO DE 12 FATURAS`}
            grey
            id={`electricityConsumptionsRegistration`}
            className={electricityListInvalid && `invalid`}
            compact={iframed}
          >
            {ELECTRICITY_CONSUMPTION_REGISTRY &&
              <Tip data-slot='tip' text={ELECTRICITY_CONSUMPTION_REGISTRY} />}
            {electricityConsumptionsRegistration && electricityConsumptionsRegistration.map((item, index) =>
              <TableItem
                key={`ti-${item.id}-${index}`}
                {...item}
                consumptionDisaggregation={consumptionDisaggregation}
                onChange={(values) => this.setTableElectricityValues(values, index)}
                onRemove={() => this.onRemoveElectricityValue(index)}
                invalid={
                  electricityListInvalid &&
                  electricityListInvalid.errors &&
                  electricityListInvalid.errors[index]
                }
              />
            )}

            {canAddElectricityItems &&
              <PlusButton
                text={`Adicionar registo`}
                onClick={() => this.addNewElectricityTableValue()}
              />
            }
          </Section>
          }

          {isGas &&
          <Section
            title={`Registo dos consumos de Gás`}
            subtitle={`INTRODUZA ATÉ UM MÁXIMO DE 12 FATURAS`}
            id={`gasConsumptionsRegistration`}
            className={gasListInvalid && `invalid`}
            compact={iframed}
          >
            {GAS_CONSUMPTION_REGISTRY &&
              <Tip data-slot='tip' text={GAS_CONSUMPTION_REGISTRY} />}
            {gasConsumptionsRegistration && gasConsumptionsRegistration.map((item, index) =>
              <TableItem
                key={`tg-${index}`}
                {...item}
                onChange={(values) => this.setTableGasValues(values, index)}
                onRemove={() => this.onRemoveGasValue(index)}
                invalid={
                  gasListInvalid &&
                  gasListInvalid.errors &&
                  gasListInvalid.errors[index]
                }
              />
            )}

            {canAddGasItems &&
              <PlusButton
                text={`Adicionar registo`}
                onClick={() => this.addNewGasTableValue()}
              />
            }
          </Section>
          }
        </FixedWrapper>
        {this.renderButtons()}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`

`



// WEBPACK FOOTER //
// ./src/containers/Consume/index.js